const Suricata = () => {
    return {
        token: function (stream, state) {
            var ch = stream.peek();

            if (stream.match(/"(?:[^\\]|\\.)*?(?:"|$)/)) { return 'string' }
            if (stream.match(/#.*/)) { return 'comment' }
            if (stream.match(/(?:tcp|udp|icmp|ip|msg|reference|gid|sid|rev|classtype|priority|metadata|flow|threshold|pcre|flowbits|content|protected_content|hash|length|nocase|rawbytes|depth|offset|distance|within|http_client_body|http_cookie|http_raw_cookie|http_header|http_raw_header|http_method|http_uri|http_raw_uri|http_stat_code|http_stat_msg|http_encode|fast_pattern|uricontent|urilen|MSG|REFERENCE|GID|SID|REV|CLASSTYPE|PRIORITY|METADATA|CONTENT|PROTECTED_CONTENT|HASH|LENGTH|NOCASE|RAWBYTES|DEPTH|OFFSET|DISTANCE|WITHIN|HTTP_CLIENT_BODY|HTTP_COOKIE|HTTP_RAW_COOKIE|HTTP_HEADER|HTTP_RAW_HEADER|HTTP_METHOD|HTTP_URI|HTTP_RAW_URI|HTTP_STAT_CODE|HTTP_STAT_MSG|HTTP_ENCODE|FAST_PATTERN|URICONTENT|URILEN)\b/)) { return 'keyword' }
            if (stream.match(/(&|\+\=|=)/)) { return 'operator' }
            if (stream.match(/0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i)) { return 'number' }

            /* nothing found, continue */
            state.pairStart = false;
            state.escaped = (ch == '\\');
            stream.next();
            return null;
        },
        startState: function () {
            return {
                pair: false,
                pairStart: false,
                keyCol: 0,
                inlinePairs: 0,
                inlineList: 0,
                literal: false,
                escaped: false
            };
        },
        lineComment: '#',
        fold: 'indent',
        dontIndentStates: ['comment'],
    };
};

export {
    Suricata as default
};
